import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import Advice from '~root/src/components/Advice.vue?shadow'
window.customElements.define('device-advice', wrap(Vue, Advice))

import Dial from '~root/src/components/Dial.vue?shadow'
window.customElements.define('device-dial', wrap(Vue, Dial))

import DidYouKnow from '~root/src/components/DidYouKnow.vue?shadow'
window.customElements.define('device-did-you-know', wrap(Vue, DidYouKnow))

import Instrumentation from '~root/src/components/Instrumentation.vue?shadow'
window.customElements.define('device-instrumentation', wrap(Vue, Instrumentation))

import LineChart from '~root/src/components/LineChart.vue?shadow'
window.customElements.define('device-line-chart', wrap(Vue, LineChart))

import SensorCard from '~root/src/components/SensorCard.vue?shadow'
window.customElements.define('device-sensor-card', wrap(Vue, SensorCard))

import SensorCardList from '~root/src/components/SensorCardList.vue?shadow'
window.customElements.define('device-sensor-card-list', wrap(Vue, SensorCardList))

import SensorHistory from '~root/src/components/SensorHistory.vue?shadow'
window.customElements.define('device-sensor-history', wrap(Vue, SensorHistory))

import SensorLiveView from '~root/src/components/SensorLiveView.vue?shadow'
window.customElements.define('device-sensor-live-view', wrap(Vue, SensorLiveView))

import SensorViewSelector from '~root/src/components/SensorViewSelector.vue?shadow'
window.customElements.define('device-sensor-view-selector', wrap(Vue, SensorViewSelector))

import StandardFooter from '~root/src/components/StandardFooter.vue?shadow'
window.customElements.define('device-standard-footer', wrap(Vue, StandardFooter))